module.exports = __webpack_public_path__ + "img/zhifubao-logo.46202bda.png";